
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as crew8uU8_45rhA8rovZmrEXTpszrmHsUOywAyTpnRAOylAsF8Meta } from "/opt/app-root/src/pages/crew.vue?macro=true";
import { default as indexkmHzTJ6CwmOD7gcPee9EO5gwYrW8owLMfuEGAgAlDRkMeta } from "/opt/app-root/src/pages/index.vue?macro=true";
import { default as login3_45twYa_45CPQfqWX2CMnSw0sRCYRaWGTjTl2W2DEhYJ4oMeta } from "/opt/app-root/src/pages/login.vue?macro=true";
import { default as saturation5EzBKWCM8tqfnvBz801VPVXx7xFaPjViycK8mxToFLcMeta } from "/opt/app-root/src/pages/saturation.vue?macro=true";
import { default as schedulingXil5epRiS6YsCUIYt4oJ8tAgQW3Pn04_45aV6P9comdHwMeta } from "/opt/app-root/src/pages/scheduling.vue?macro=true";
import { default as healthcheckbg2efiP_45Eqsm8nAqbRxOYIXW74xWVsC_45I8vBUI_45y_45ikMeta } from "/opt/app-root/src/pages/healthcheck.vue?macro=true";
import { default as availability_fo3Kyek1ZMkL1n05tpOutBhhEJarRa8EkAf_45mUH5j8Meta } from "/opt/app-root/src/pages/availability.vue?macro=true";
export default [
  {
    name: "crew___en",
    path: "/en/crew",
    meta: { ...(crew8uU8_45rhA8rovZmrEXTpszrmHsUOywAyTpnRAOylAsF8Meta || {}), ...{"middleware":["auth","check-technician"]} },
    component: () => import("/opt/app-root/src/pages/crew.vue")
  },
  {
    name: "crew___es",
    path: "/crew",
    meta: { ...(crew8uU8_45rhA8rovZmrEXTpszrmHsUOywAyTpnRAOylAsF8Meta || {}), ...{"middleware":["auth","check-technician"]} },
    component: () => import("/opt/app-root/src/pages/crew.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: { ...(indexkmHzTJ6CwmOD7gcPee9EO5gwYrW8owLMfuEGAgAlDRkMeta || {}), ...{"middleware":["auth","check-admin"]} },
    component: () => import("/opt/app-root/src/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/",
    meta: { ...(indexkmHzTJ6CwmOD7gcPee9EO5gwYrW8owLMfuEGAgAlDRkMeta || {}), ...{"middleware":["auth","check-admin"]} },
    component: () => import("/opt/app-root/src/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/login",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/pages/login.vue")
  },
  {
    name: "saturation___en",
    path: "/en/saturation",
    meta: { ...(saturation5EzBKWCM8tqfnvBz801VPVXx7xFaPjViycK8mxToFLcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/app-root/src/pages/saturation.vue")
  },
  {
    name: "saturation___es",
    path: "/saturation",
    meta: { ...(saturation5EzBKWCM8tqfnvBz801VPVXx7xFaPjViycK8mxToFLcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/app-root/src/pages/saturation.vue")
  },
  {
    name: "scheduling___en",
    path: "/en/scheduling",
    meta: { ...(schedulingXil5epRiS6YsCUIYt4oJ8tAgQW3Pn04_45aV6P9comdHwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/app-root/src/pages/scheduling.vue")
  },
  {
    name: "scheduling___es",
    path: "/scheduling",
    meta: { ...(schedulingXil5epRiS6YsCUIYt4oJ8tAgQW3Pn04_45aV6P9comdHwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/app-root/src/pages/scheduling.vue")
  },
  {
    name: "healthcheck___en",
    path: "/en/healthcheck",
    component: () => import("/opt/app-root/src/pages/healthcheck.vue")
  },
  {
    name: "healthcheck___es",
    path: "/healthcheck",
    component: () => import("/opt/app-root/src/pages/healthcheck.vue")
  },
  {
    name: "availability___en",
    path: "/en/availability",
    meta: { ...(availability_fo3Kyek1ZMkL1n05tpOutBhhEJarRa8EkAf_45mUH5j8Meta || {}), ...{"middleware":["auth","check-technician"]} },
    component: () => import("/opt/app-root/src/pages/availability.vue")
  },
  {
    name: "availability___es",
    path: "/availability",
    meta: { ...(availability_fo3Kyek1ZMkL1n05tpOutBhhEJarRa8EkAf_45mUH5j8Meta || {}), ...{"middleware":["auth","check-technician"]} },
    component: () => import("/opt/app-root/src/pages/availability.vue")
  }
]